// extracted by mini-css-extract-plugin
module.exports = {"menu":"App_menu__3dqVM"};